const formatNumber = (amount: number) => {
  const cash = Math.round(amount / 10) * 10;
  if (cash === undefined) {
    return 0;
  }
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export { formatNumber };
